import type {EditSupplierNoteFormPayload} from "./edit-supplier-note.schema";

import {editSupplierNote} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {supplierKeys, supplierMutationKeys} from "../../../../../supplier-keys";

export function editSupplierNoteMutationOptions(supplierId: string, noteId: number) {
  return mutationOptions({
    mutationKey: supplierMutationKeys.editSupplierNote,
    mutationFn: (payload: EditSupplierNoteFormPayload) =>
      editSupplierNote(supplierId, noteId, payload),
    onSuccess: async (_data, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: supplierKeys.detail(supplierId)}),
        client.invalidateQueries({queryKey: supplierKeys.lists()}),
      ]);
    },
  });
}
